var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 2.66671C6.29848 2.66671 6 2.96518 6 3.33337V10C6 10.3682 6.29848 10.6667 6.66667 10.6667H12C12.3682 10.6667 12.6667 10.3682 12.6667 10V5.60952L9.72386 2.66671H6.66667ZM4.66667 3.33337C4.66667 2.2288 5.5621 1.33337 6.66667 1.33337H9.72386C10.0775 1.33337 10.4166 1.47385 10.6667 1.7239L13.6095 4.66671C13.8595 4.91676 14 5.2559 14 5.60952V10C14 11.1046 13.1046 12 12 12H11.3333V12.6667C11.3333 13.7713 10.4379 14.6667 9.33333 14.6667H4C2.89543 14.6667 2 13.7713 2 12.6667V6.00004C2 4.89547 2.89543 4.00004 4 4.00004H4.66667V3.33337ZM4.66667 5.33337H4C3.63181 5.33337 3.33333 5.63185 3.33333 6.00004V12.6667C3.33333 13.0349 3.63181 13.3334 4 13.3334H9.33333C9.70152 13.3334 10 13.0349 10 12.6667V12H6.66667C5.5621 12 4.66667 11.1046 4.66667 10V5.33337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDuplicate);
export default __webpack_public_path__ + "static/media/document-duplicate.22e3a005eead5d4da36b8113b22e1616.svg";
export { ForwardRef as ReactComponent };